import { TabloPageStructureUpdate } from '@ui/tablo-generator/types';

export interface QueuedTabloPageStructureUpdate
  extends TabloPageStructureUpdate {
  sessionId: number;
}

type TimeoutHandle = ReturnType<typeof setTimeout>;

export class TabloStructureUpdateQueue {
  private pending: QueuedTabloPageStructureUpdate | null = null;
  private timer: TimeoutHandle | null = null;

  constructor(
    private readonly emit: (update: TabloPageStructureUpdate) => void,
    private readonly debounceMs = 100,
  ) {}

  enqueue(
    update: QueuedTabloPageStructureUpdate,
  ): void {
    if (this.pending && this.pending.sessionId !== update.sessionId) {
      this.flushPending();
    }

    this.pending = update;

    if (this.timer) {
      clearTimeout(this.timer);
    }

    const sessionId = update.sessionId;
    this.timer = setTimeout(() => {
      if (!this.pending || this.pending.sessionId !== sessionId) {
        return;
      }

      this.flushPending();
    }, this.debounceMs);
  }

  flushPending(): void {
    if (!this.pending) {
      if (this.timer) {
        clearTimeout(this.timer);
        this.timer = null;
      }
      return;
    }

    if (this.timer) {
      clearTimeout(this.timer);
      this.timer = null;
    }

    const { sessionId: _sessionId, ...update } = this.pending;
    this.pending = null;
    this.emit(update);
  }
}
